import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Table, Spinner, Button, Form, Badge, InputGroup } from 'react-bootstrap';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API_BASE_URL, getBearerToken } from '../../../functions';
import UmrahTRLoop from '../umrah-compo/UmrahTRLoop';
import searchicon from '../../../images/searchicon.svg';

const UmrahHistory = () => {
  const [packages, setPackages] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [date, setDate] = useState('');

  useEffect(() => {
    const tid = toast.loading('Please wait...');
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/umrah-packages-history?page=${currentPage}&status=closed${search ? `&search=${encodeURIComponent(search)}` : ''}${date ? `&date=${date}` : ''}`, {
        headers: { Authorization: `Bearer ${getBearerToken()}` },
      })
      .then((res) => {
        const data = res?.data?.data;
        if (currentPage === 1) {
          setPackages(data?.data || []);
        } else {
          setPackages((prev) => [...prev, ...(data?.data || [])]);
        }
        setMeta(data);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        toast.dismiss(tid);
      });
  }, [currentPage, search, date]);

  const handleSearch = (e) => {
    e.preventDefault();
    setCurrentPage(1);
  };

  return (
    <>
      <div className={'main_heading mb-4 d-flex align-items-center'}>
        <h4>Umrah History : {meta?.total || 0}</h4>
      </div>
      <Card style={{ boxShadow: '0px 0px 2px rgba(145,158,171,0.2), 0px 12px 24px -4px rgba(145,158,171,0.12)' }}>
        <Card.Header className='px-3 px-lg-4 py-3 d-flex justify-content-between align-items-center' style={{ background: 'transparent', border: 'none' }}>
          <h5 className={'fontsize18 blacktext fontweight600'}>Umrah History</h5>
          <div className='d-flex'>
            <Form onSubmit={handleSearch} className='me-2'>
              <InputGroup className='mb-0 d-md-flex d-none border rounded'>
                <Form.Control className='border-0' placeholder='Search by Title' onChange={(e) => setSearch(e.target.value)} value={search} />
                <Button variant={''} type='submit' id='umrah-history-search-btn'><img className={'img-fluid'} src={searchicon} alt={'icon'} /></Button>
              </InputGroup>
            </Form>
            <Form className='me-2'>
              <InputGroup className='mb-0 d-md-flex d-none border rounded'>
                <Form.Control className='border-0' type='date' onChange={(e) => { setDate(e.target.value); setCurrentPage(1); }} value={date} />
              </InputGroup>
            </Form>
            {(date || search) ? <Button className='redtext' variant={''} type='button' onClick={() => { setDate(''); setSearch(''); setCurrentPage(1); }}>Clear</Button> : null}
          </div>
        </Card.Header>
        <Card.Body className={'p-0 mb-3'}>
          <Table responsive={'sm'} className={'mb-0 allView'}>
            <thead className={'thead-dark'}>
              <tr>
                <th>Title</th>
                <th>Dates</th>
                <th>Routes</th>
                <th>Airlines</th>
                <th style={{ width: '200px' }}>Prices</th>
                <th>Seats</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <UmrahTRLoop packages={packages} 
                onDelete={async (id) => {
                  const tid = toast.loading('Deleting...');
                  try {
                    await axios.delete(`${API_BASE_URL}/umrah-package/${id}`, { headers: { Authorization: `Bearer ${getBearerToken()}` } });
                    setPackages((prev) => prev.filter((x) => x.id !== id));
                    toast.success('Deleted');
                  } catch {
                    toast.error('Delete failed');
                  } finally { toast.dismiss(tid); }
                }}
                onClose={async (id) => {
                  const tid = toast.loading('Closing...');
                  try {
                    await axios.post(`${API_BASE_URL}/umrah-package/${id}/status`, { status: 'closed' }, { headers: { Authorization: `Bearer ${getBearerToken()}` } });
                    setPackages((prev) => prev.filter((x) => x.id !== id));
                    toast.success('Package closed');
                  } catch {
                    toast.error('Close failed');
                  } finally { toast.dismiss(tid); }
                }}
                onActivate={async (id) => {
                  const tid = toast.loading('Activating...');
                  try {
                    await axios.post(`${API_BASE_URL}/umrah-package/${id}/status`, { status: 'active' }, { headers: { Authorization: `Bearer ${getBearerToken()}` } });
                    setPackages((prev) => prev.filter((x) => x.id !== id));
                    toast.success('Package activated');
                  } catch {
                    toast.error('Activation failed');
                  } finally { toast.dismiss(tid); }
                }}
              />
            </tbody>
          </Table>
          {loading && (
            <div className={'mt-3 w-100 text-center'}>
              <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' />
            </div>
          )}
          {(!packages || packages.length < 1) && !loading && (
            <div className={'mt-3 w-100 text-center'}><p>No Umrah History Found</p></div>
          )}
        </Card.Body>
        <Card.Footer className='px-3 px-lg-4 py-3 text-end' style={{ background: 'transparent' }}>
          <div className='d-flex justify-content-end'>
            <Button disabled={!meta?.prev_page_url} className='me-2' onClick={() => { if (meta?.prev_page_url) setCurrentPage((p) => Math.max(1, p - 1)); }}>Prev</Button>
            <Button disabled={!meta?.next_page_url} onClick={() => { if (meta?.next_page_url) setCurrentPage((p) => p + 1); }}>Next</Button>
          </div>
        </Card.Footer>
      </Card>
    </>
  );
};

export default UmrahHistory;
